import { connect } from 'react-redux';

import TriggerInputEditor from 'app/developer-v3/pages/triggers/TriggerInputEditor/TriggerInputEditor';
import {
  availableTriggers,
  isCurrentAppDefinitionSaving,
} from 'app/developer-v3/selectors';

const mapStateToProps = state => ({
  isSaving: isCurrentAppDefinitionSaving(state),
  availableTriggers: availableTriggers(state),
});

export default connect(mapStateToProps)(TriggerInputEditor);
